import React, {memo} from 'react';

import {emojiToUrl} from '../../../../srcCommon/helpers/emoji/emojiHelpers';
import {usePush} from '../../../../srcCommon/push/pushContext';
import {isCustomEmoji} from '../../../services/emojis/emojis';
import {EmojiInheritableProps} from '../../../services/emojis/emojiTypes';
import {SheetEmoji} from './sheetEmoji';

/*
 * Component.
 */

export const Emoji = memo<EmojiInheritableProps>((props) => {
  const {isConnected} = usePush();
  const {emoji, useSheet} = props;
  if ((!isConnected || useSheet) && !isCustomEmoji(emoji)) {
    return <SheetEmoji {...props} />;
  }

  const {skinTone} = props;
  const emojiUrl = emojiToUrl(emoji, skinTone);

  return (
    <img
      alt={emoji.shortcode}
      src={emojiUrl}
      style={{
        display: 'block',
        height: props.size || '100%',
        width: props.size || '100%',
        fontSize: 0,
        objectFit: 'contain',
      }}
    />
  );
});
